module.exports = __webpack_public_path__ + "static/media/trazitar-eCommerce.b1918a90.png";